<div class="flex items-center w-full h-full flex-col !pt-4">
  <nz-select
    *ngIf="!props?.readonly"
    style="width: 500px"
    [nzServerSearch]="props.nzServerSearch"
    [nzShowSearch]="true"
    [(ngModel)]="selectedValue"
    [nzPlaceHolder]="to.placeholder || ''"
    (ngModelChange)="handlerSelectChange($event)"
    (nzScrollToBottom)="loadMore()"
    nzAllowClear
    [nzMaxMultipleCount]="5"
    [nzDropdownMatchSelectWidth]="false"
    [nzDropdownRender]="renderTemplate"
    (nzOnSearch)="onSearch($event)"
    (nzOpenChange)="onSelectOpenChange($event)"
  >
    <ng-template #renderTemplate>
      <div *ngIf="isLoading" class="loading-container absolute top-5 left-1/2">
        <nz-spin nzSize="large"></nz-spin>
      </div>
    </ng-template>

    <ng-container *ngIf="props?.customOption">
      <nz-option
        *ngFor="let option of optionList"
        [nzValue]="option.id"
        [nzDisabled]="option.disabled"
        appShowTooltipOnOverflow
        nzCustomContent
      >
        <div>
          <div class="option-content flex items-center">
            <div class="option-image mr-2">
              <img
                nz-image
                [nzSrc]="
                  option?.medias?.[0]?.url ||
                  'data:image/png;base64,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'
                "
                (error)="onImageError($event)"
                (click)="$event.preventDefault()"
                alt="Voucher Image"
                class="h-12 w-12 object-cover pointer-events-none"
              />
            </div>
            <div
              class="flex flex-col justify-between h-full w-full overflow-hidden"
            >
              <div class="voucher-info">
                <div
                  class="overflow-hidden text-ellipsis whitespace-nowrap"
                  appShowTooltipOnOverflow
                  nz-tooltip
                  [nzTooltipTitle]="option.name"
                >
                  {{ option?.name || '-' }}
                </div>
                <div class="voucher-details text-sm">
                  <div class="flex justify-between">
                    <span>ID: {{ option.id }}</span>
                  </div>

                  <div class="flex justify-between">
                    <span
                      >Tồn:
                      {{
                        option?.quantity_available_by_gen_code_type
                          | formatValue
                      }}</span
                    >
                    <div></div>
                  </div>

                  <!-- <div class="flex justify-between">
                    <span
                      >Giá:
                      {{
                        option?.price | formatValue
                      }}</span
                    >
                    <div></div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </nz-option>
    </ng-container>
    <ng-container *ngIf="!props?.customOption">
      <nz-option
        *ngFor="let option of optionList"
        [nzValue]="option.id"
        [nzLabel]="option.value || option.name || option.title"
      ></nz-option>
    </ng-container>
  </nz-select>

  <div
    *ngIf="props?.import && !props?.readonly"
    class="w-full justify-end flex my-2"
  >
    <button nz-button [nzType]="'primary'" (click)="openImportModal($event)">
      <span nz-icon nzType="plus" nzTheme="outline"></span>
      Nhập file excel
    </button>
  </div>

  <div class="w-full h-full mt-4 overflow-hidden">
    <nz-table
      [nzFrontPagination]="false"
      [nzPageSize]="10"
      class="mt-2 w-full"
      #nzTable
      [nzBordered]="true"
      [nzNoResult]="noResultTemplate"
      [nzData]="pagedItems"
      [nzTableLayout]="'fixed'"
    >
      <thead>
        <tr>
          <ng-container *ngFor="let col of props.columns">
            <th
              [nzWidth]="col.width"
              [hidden]="col.hiddenWhenReadonly && props.readonly"
              class="text-xs font-semibold"
            >
              {{ col.name }}
            </th>
          </ng-container>
        </tr>
      </thead>
      <tbody cdkDropList (cdkDropListDropped)="drop($event)">
        <tr
          #tableRow
          id="row-{{ data.id || data.product_id }}"
          *ngFor="let data of pagedItems; let i = index"
          cdkDrag
        >
          <ng-container *ngFor="let col of props.columns">
            <td
              [hidden]="col.hiddenWhenReadonly && props.readonly"
              class="text-xs overflow-hidden text-ellipsis !p-3">
              <ng-container [ngSwitch]="col.type">
                <ng-container *ngSwitchCase="'index'">
                  <i
                    *ngIf="!props?.readonly"
                    nz-icon
                    class="cursor-pointer"
                    nzType="menu"
                    cdkDragHandle
                  ></i>
                  <span *ngIf="props?.readonly">{{ ((!getCurrentPage ? 0 : getCurrentPage - 1)) * ($any(paginationService.getPageSize() || 10)) + i + 1 }}</span>
                </ng-container>
                <ng-container *ngSwitchCase="'stt'">
                  <span>{{((!getCurrentPage ? 0 : getCurrentPage - 1)) * ($any(paginationService.getPageSize() || 10)) + i + 1 }}</span>
                </ng-container>
                <div
                  *ngSwitchCase="'text'"
                  class="overflow-hidden text-ellipsis whitespace-nowrap"
                  nz-tooltip
                  [nzTooltipTitle]="data[col.field]"
                >
                  <ng-container
                    *ngIf="
                      data[col.field] === null || data[col.field] === undefined;
                      else notNullValue
                    "
                  >
                    <span>-</span>
                  </ng-container>
                  <ng-template #notNullValue>
                    <span
                      *ngIf="
                        isNumber(data[col.field]) && !col?.ignoreParseNumber
                      "
                      >{{ data[col.field] | formatValue }}</span
                    >
                    <span
                      *ngIf="
                        isNumber(data[col.field]) && col?.ignoreParseNumber
                      "
                      >{{ data[col.field] }}</span
                    >
                    <span *ngIf="isString(data[col.field])">{{
                      data[col.field]
                    }}</span>
                  </ng-template>
                </div>

                <div *ngSwitchCase="'text-link'">
                  <a
                    *ngIf="col?.props?.clickAction"
                    nz-button
                    [nzSize]="'default'"
                    nzType="link"
                    (click)="col?.props?.clickAction(data)"
                  >
                    <ng-container
                      *ngIf="
                        data[col.field] === null ||
                          data[col.field] === undefined;
                        else notNullValue
                      "
                    >
                      <span>-</span>
                    </ng-container>
                    <ng-template #notNullValue>
                      <span *ngIf="isNumber(data[col.field])">{{
                        data[col.field] | formatValue
                      }}</span>
                      <span *ngIf="isString(data[col.field])">{{
                        data[col.field]
                      }}</span>
                    </ng-template>
                  </a>
                </div>

                <ng-container *ngSwitchCase="'input'">
                  <app-table-input
                    #templates
                    class="w-full"
                    [type]="col.inputType"
                    [value]="data[col.field] || ''"
                    [readonly]="props.readonly"
                    [placeholder]="col.placeholder"
                    [required]="col.required"
                    [max]="col.max"
                    [min]="col.min"
                    [dataRow]="data"
                    [props]="col?.props"
                    (valueChange)="handlerChange($event, data, col.field)"
                  >
                  </app-table-input>
                </ng-container>
                <ng-container *ngSwitchCase="'multi-select'">
                  <app-table-select-multi
                    class="w-full"
                    [options]="col.options"
                    [value]="data[col.field]"
                    [readonly]="props.readonly"
                    [placeholder]="col.placeholder"
                    (valueChange)="handlerChange($event, data, col.field)"
                  >
                  </app-table-select-multi>
                </ng-container>
                <ng-container *ngSwitchCase="'action'">
                  <button
                    *ngIf="!props?.readonly"
                    nz-button
                    nzType="primary"
                    [nzDanger]="true"
                    (click)="removeItem($event, data)"
                  >
                    Xóa
                  </button>
                </ng-container>
              </ng-container>
            </td>
          </ng-container>
        </tr>
      </tbody>
    </nz-table>
  </div>
  <nz-pagination
    *ngIf="pagedItems && pagedItems.length"
    [nzTotal]="totalPages * 10"
    [nzPageIndex]="getCurrentPage"
    nzShowSizeChanger [nzPageSize]="10"
    [nzPageSizeOptions]="[10, 20, 30, 50, 100]"
    (nzPageIndexChange)="setCurrentPage($event)"
    (nzPageSizeChange)="onPageSizeChange($event)"  
  ></nz-pagination>
</div>

<ng-template #noResultTemplate>
  <div class="flex flex-col items-center justify-center h-52">
    <i nz-icon nzType="frown" nzTheme="outline" class="text-4xl mb-2"></i>
    <span class="block">Không có dữ liệu</span>
  </div>
</ng-template>
